import * as d3 from 'd3'

export default {
  methods: {

    chart_Router() {
      this.canvasChart = this.svg
      .append('g')
      .attr('transform', `translate(0, 0)`)
      .style('font-family', 'roboto').attr('cursor', 'default')

      this.chart.group.forEach(d=> {
        
        let chtData = this.chartData.filter(f=> f[this.radio.radioCode] == this.current.value && f[this.chart.chartCode] == d.value )

        this.set_Timeline(chtData) //-----> below
        this.set_maxValue(chtData) //-----> below

        this.draw_ChartCanvas(d, chtData) // -----> draw_Elements.js
        
      })
      
    },



    set_Timeline(chtDate) {

      // Timeline
      this.timeline.axis = null
      this.timeline.xItems = []

      // Setting Timeline ------------------------------
      let unique = [ ...new Set(chtDate.map(m => m[this.timeline.refCode])) ]
      this.timeline.axis = d3.scaleBand()
      .domain(unique)
      .range([0, this.chart.width])
      this.timeline.band = this.timeline.axis.bandwidth()
      
      unique.forEach((d,i)=> {
        
        let total = 0
        this.chart.styles.filter(f=> f.type == 'BAR').forEach(s => {
          total += chtDate.find(f=> f[this.timeline.refCode] == d)[s.code]
        })

        let mid = this.timeline.axis(d) + this.timeline.band / 2
        this.timeline.xItems.push({
          name: d,
          sx: this.timeline.axis(d),
          mx: mid,
          ex: this.timeline.axis(d) + this.timeline.band,

          
          sum: total
        })
      })
    },



    set_maxValue(chtDate) {

      // Initial
      this.primary.max = null
      this.primary.axis = null
      this.secondary.max = null
      this.secondary.axis = null

      // Primary
      this.primary.max = this.primary.maxValue || this.gmx_maxBound5(d3.max(this.timeline.xItems, c => c.sum))

      this.primary.axis = d3.scaleLinear()
      .domain([0, this.primary.max])
      .range([0, this.chart.height])



      // Setting secondary
      if(this.secondary.visible == 'Y') {

        if(this.secondary.maxValue == 0) {
          let maxArray = []
          this.chart.styles.filter(f=> f.type == 'LINE').forEach(s => {
            maxArray.push(d3.max(chtDate, c => c[s.code]))
          })
          this.secondary.max = this.gmx_maxBound5(d3.max(maxArray))
        } else {
          this.secondary.max = this.secondary.maxValue
        }

        this.secondary.axis = d3.scaleLinear()
        .domain([0, this.secondary.max])
        .range([this.chart.height, 0])
      }

    },

  }
}
           